export var FIELD_NAMES;
(function (FIELD_NAMES) {
    FIELD_NAMES["STATUS"] = "status";
    FIELD_NAMES["LIST_NAME"] = "listName";
    FIELD_NAMES["DESCRIPTION"] = "description";
    FIELD_NAMES["VISIBILITY"] = "visibility";
    FIELD_NAMES["RECORD_TYPE"] = "recordType";
})(FIELD_NAMES || (FIELD_NAMES = {}));
export var VISIBILITY_VALUES;
(function (VISIBILITY_VALUES) {
    VISIBILITY_VALUES["PRIVATE"] = "private";
    VISIBILITY_VALUES["SHARED"] = "shared";
})(VISIBILITY_VALUES || (VISIBILITY_VALUES = {}));
export var STATUS_VALUES;
(function (STATUS_VALUES) {
    STATUS_VALUES["ACTIVE"] = "active";
    STATUS_VALUES["INACTIVE"] = "inactive";
})(STATUS_VALUES || (STATUS_VALUES = {}));
